const valueError = {
  en: {
    missing: "field required",
    email: "value is not a valid email address"
  },
  pt: {
    missing: "é um campo obrigatório",
    email: "valor não é um endereço de e-mail válido"
  },
  es: {
    missing: "es un campo obligatorio",
    email: "el valor no es una dirección de correo electrónico válida"
  }
}

export default valueError
